// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"589":"1d1720d5","787":"69e70e80"}[chunkId] + ".chunk.js";
};